import { createContext, useReducer, useState, useContext } from 'react'

export const ApplicationTypeContext = createContext() 

export const applicationTypeReducer = (state, action) => {
  switch (action.type) {
    case 'SET_APPLICATION_TYPE':
      return { appTypes: action.payload }
    case 'CREATE_APPLICATION_TYPE':
      return { appTypes: [action.payload, ...state.appTypes] }
    case 'UPDATE_APPLICATION_TYPE':
      return {
        ...state,
        appTypes: state.appTypes.map(appType =>
          appType._id === action.payload._id
            ? action.payload
            : appType
        )
      }
    case 'DELETE_APPLICATION_TYPE':
      return { appTypes: state.appTypes.filter(at => at._id !== action.payload._id) }
    default:
      return state
  }
}

export const ApplicationTypeContextProvider = ({children}) => {
  const [state, dispatchAppType] = useReducer(applicationTypeReducer, { appTypes: null })
  const [targetApplicationType, setTargetApplicationType] = useState()
  return (<ApplicationTypeContext.Provider value={{ ...state, dispatchAppType, targetApplicationType, setTargetApplicationType}}>{ children }</ApplicationTypeContext.Provider>)
}

export const useApplicationTypeContext = () => {
  const context = useContext(ApplicationTypeContext)
  if(!context) throw Error('useApplicationTypeContext must be used inside an ApplicationTypeContextProvider')
  return context
}